import { createSlice } from "@reduxjs/toolkit";

const templateSlice = createSlice({
  name: "templateSetter",
  initialState: {
    templateName: "",
    templateType: "",
    templateDescription: "",
    baseTemplateId: "",
    templateId: null,
    templateParameterId: null,
    templateLoading: true,
    backFromAllTemplates: false,
    isContentFlag: false,
    isOffer: false,
    currentTab: "emailTab",
  },
  reducers: {
    setTemplateName: (state, action) => {
      state.templateName = action.payload;
    },
    setTemplateType: (state, action) => {
      state.templateType = action.payload;
    },
    setTemplateDescription: (state, action) => {
      state.templateDescription = action.payload;
    },
    setTemplateId: (state, action) => {
      state.templateId = action.payload;
    },
    setTemplateParameterId: (state, action) => {
      state.templateParameterId = action.payload;
    },
    setBackFromAllTemplates: (state, action) => {
      state.backFromAllTemplates = action.payload;
    },
    setIsContentFlag: (state, action) => {
      state.isContentFlag = action.payload;
    },
    setBaseTemplateId: (state, action) => {
      state.baseTemplateId = action.payload;
    },
    setTemplateLoading: (state, action) => {
      state.templateLoading = action.payload;
    },
    setISOffer: (state, action) => {
      state.isOffer = action.payload;
    },
    setCurrentTab: (state, action) => {
      state.currentTab = action.payload;
    },
    resetTemplateData: (state , action) => {
      state.templateName = "";
      state.templateType = "";
      state.templateDescription = "";
      state.templateId = null;
      state.templateParameterId = "";
      state.backFromAllTemplates = false;
      state.isContentFlag = false;
      state.isOffer = false;
      state.currentTab = action.payload? action.payload :"emailTab";
    },
  },
});

export const {
  setTemplateName,
  setTemplateType,
  setTemplateDescription,
  setTemplateId,
  setTemplateParameterId,
  setBackFromAllTemplates,
  resetTemplateData,
  setIsContentFlag,
  setTemplateLoading,
  setBaseTemplateId,
  setISOffer,
  setCurrentTab,
} = templateSlice.actions;

export default templateSlice.reducer;
